module.exports = __webpack_public_path__ + "static/media/it-craft-logo-light.b57abb76.svg";